import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {PageHeader} from "../components/layout/PageHeader";
import {showSuccess} from "../components/Notification";
import {useAuthenticatedUser, useUserMe, useRolesMe} from "../hooks/user";
import {Button, Col, Form, Input, Row, Spin} from "antd";
import {validatePassword, validateRepeatPassword} from "../utils/validator";
import {Eye, EyeOff, User} from "react-feather";
import {BackButton} from "../components/layout/BackButton";

export function ProfilePage() {
    const {t} = useTranslation();

    const userRoles = useRolesMe();
    const userMeResponse = useUserMe();
    const userMe = userMeResponse.data || {};

    const [passwordForm] = Form.useForm();
    const [passwordLoading, setPasswordLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);

    const authenticatedUser = useAuthenticatedUser();

    const changePassword = (values: any): void => {
        const {oldPassword, newPassword} = values;
        if (authenticatedUser) {
            setPasswordLoading(true);
            authenticatedUser.changePassword(oldPassword, newPassword, (error: any, success: any) => {
                setPasswordLoading(false);
                if (error) {
                    console.error(error);
                }
                if (success) {
                    passwordForm.resetFields();
                    setShowPassword(false);
                    setShowRepeatPassword(false);
                    showSuccess(t('general.success'), t('profile.passwordChanged'));
                }
            });
        }
    };

    return (
        <Spin spinning={userMeResponse.loading || passwordLoading}>
            <PageHeader/>
            <div className={'top-block accent7-background'}>
                <h1 className={'h1'}><BackButton/><User/>{t('profile.title')}</h1>
            </div>
            <div className={'subpage-content'}>
                <Form name="profile" labelCol={{span: 11}} className={'mb-05'}>
                    <Row>
                        <Col span={24} md={12} xl={8}>
                            <Form.Item label={t('user.username')}>
                                <Input value={(userMe || {}).username} readOnly/>
                            </Form.Item>
                        </Col>
                        <Col span={24} md={12} xl={8}>
                            <Form.Item label={t('user.firstName')}>
                                <Input value={(userMe || {}).firstName} readOnly/>
                            </Form.Item>
                        </Col>
                        <Col span={24} md={12} xl={8}>
                            <Form.Item label={t('user.lastName')}>
                                <Input value={(userMe || {}).lastName} readOnly/>
                            </Form.Item>
                        </Col>
                        <Col span={24} md={12} xl={8}>
                            <Form.Item label={t('user.email')}>
                                <Input value={(userMe || {}).email} readOnly/>
                            </Form.Item>
                        </Col>
                        <Col span={24} md={12} xl={8}>
                            <Form.Item label={t('user.phone')}>
                                <Input value={(userMe || {}).phone} readOnly/>
                            </Form.Item>
                        </Col>
                        <Col span={24} md={12} xl={8}>
                            <Form.Item label={t('user.roles')}>
                                <Input readOnly
                                       value={(userRoles || []).map((item: any) => t('user.role.' + item)).join(', ')}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <h2>{t('profile.changePassword')}</h2>
                <Form name="password"
                      form={passwordForm}
                      onFinish={changePassword}
                      autoComplete={'off'}
                      labelCol={{span: 11}}
                      validateTrigger={'onSubmit'}>
                    <Row className={'row-offset'}>
                        <Col span={24} lg={8} xl={6}>
                            <Form.Item label={t('user.oldPassword')} name={'oldPassword'} rules={[{required: true},
                                () => ({validator: (_, value) => validatePassword(value, t)})
                            ]}>
                                <Input type={'password'}/>
                            </Form.Item>
                        </Col>
                        <Col span={24} lg={8} xl={6}>
                            <Form.Item label={t('user.newPassword')} name={'newPassword'} rules={[{required: true},
                                () => ({validator: (_, value) => validatePassword(value, t)})
                            ]}>
                                <Input type={showPassword ? 'text' : 'password'} addonAfter={!showPassword ?
                                    <EyeOff onClick={() => setShowPassword(true)} className={'cursor-pointer'}/>
                                    :
                                    <Eye onClick={() => setShowPassword(false)} className={'cursor-pointer'}/>
                                }/>
                            </Form.Item>
                        </Col>
                        <Col span={24} lg={8} xl={6}>
                            <Form.Item label={t('user.repeatPassword')} name={'repeatPassword'} rules={[
                                () => ({validator: (_, value) => validateRepeatPassword(value, passwordForm.getFieldValue('newPassword'), t)})
                            ]}>
                                <Input type={showRepeatPassword ? 'text' : 'password'} addonAfter={!showRepeatPassword ?
                                    <EyeOff onClick={() => setShowRepeatPassword(true)} className={'cursor-pointer'}/>
                                    :
                                    <Eye onClick={() => setShowRepeatPassword(false)} className={'cursor-pointer'}/>
                                }/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item className={'no-margin text-right'}>
                        <Button type="primary" htmlType="submit">
                            {t('user.changePassword')}
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </Spin>
    )
}

/*
<Row className={'page-header-top'}>
  <Col span={12}>
  </Col>
  <Col span={12} className={'text-right'}>

    <input type={'password'} placeholder={t('old.password')} value={oldPassword}
           onChange={event => setOldPassword(event.target.value)}/>
    <input type={'password'} placeholder={t('new.password')} value={newPassword}
           onChange={event => setNewPassword(event.target.value)}/>
    <Button type="primary" size={'large'} onClick={changePassword}>
        {t('Change password')} <RightOutlined/>
    </Button>
      {false && <LanguageSwitch/>}
    <Button type="primary" size={'large'} onClick={logout}>
        {t('Logout')} <RightOutlined/>
    </Button>
  </Col>
</Row>
<div className={'page-header-line'}>
    <NavLink to={'/home'}>LOGO</NavLink>
    </div>
    <MainMenu/>
    */
